import Icon from '@ant-design/icons';

const AISvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5737 8.62379C12.6202 7.88139 11.0799 6.29683 10.356 4.28542C10.3097 4.15747 10.1354 4.15747 10.0891 4.28542C9.36733 6.29473 7.82684 7.87918 5.87137 8.62379C5.74698 8.6714 5.74698 8.85068 5.87137 8.89829C7.8248 9.64069 9.36518 11.2253 10.0891 13.2367C10.1354 13.3646 10.3097 13.3646 10.356 13.2367C11.0777 11.2274 12.6182 9.6429 14.5737 8.89829C14.6981 8.85068 14.6981 8.6714 14.5737 8.62379Z"
        fill="currentColor"
      />
      <path
        d="M1.37922 4.88333C2.35751 4.51194 3.12814 3.71926 3.48928 2.71291C3.51171 2.65039 3.60072 2.65039 3.62242 2.71291C3.98349 3.71918 4.75413 4.51186 5.73249 4.88333C5.79327 4.90641 5.79327 4.99796 5.73249 5.02028C4.7542 5.39168 3.98357 6.18436 3.62242 7.19071C3.59999 7.25323 3.51099 7.25323 3.48928 7.19071C3.12821 6.18444 2.35758 5.39176 1.37922 5.02028C1.31844 4.99721 1.31844 4.90566 1.37922 4.88333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AIIcon = (props: any) => <Icon component={AISvg} {...props} />;
